import { render } from "./LockTable.vue?vue&type=template&id=d161c452&ts=true"
import script from "./LockTable.vue?vue&type=script&lang=ts"
export * from "./LockTable.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__